module.exports = __webpack_public_path__ + "b55b404cc5fb186e52228fb3ac9de7f6.jpg";